export default {
  init() {
    window.trackBrokerLink = function(brokerName) {
      gtag('event', 'click', {
        'event_category': 'outclick',
        'event_label': brokerName,
        'transport_type': 'beacon',
        'event_callback': function(){}
      });
    }
  },
  finalize() {
	var $ab = $('.admin-bar');

    if ($ab.length > 0) {
      $('.nav-primary .dropdown-menu').toggleClass('transform-admin');
    } else {
      $('.nav-primary .dropdown-menu').toggleClass('transform');
    }
    $('.btn-bars', '.nav-primary-responsive').on('click', function() {
      $(this).siblings('div').toggleClass('d-block');
      $(this).parent('.nav-primary-responsive').toggleClass('show-nav');
    });

    var header_height = $('.banner').css('height');
    console.log(header_height);
    $('.below-top-nav').css('margin-top', header_height);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js